/**
 * 日本語メッセージ
 */

export const errors = {
  timeout: '通信がタイムアウトしました。',
  networkError: 'ネットワークエラーが発生しました。接続先、端末の接続状況を確認してお試しください。'
}

export const appsuite_job_status = {
  '0': '未実行',
  '1': '実行中',
  '2': 'エラーあり',
  '3': '中止',
  '4': '完了'
}



// WEBPACK FOOTER //
// ./src/lang/ja_JP.js